import { render } from "./SupportFab.vue?vue&type=template&id=4c25de0d&scoped=true"
import script from "./SupportFab.vue?vue&type=script&lang=js"
export * from "./SupportFab.vue?vue&type=script&lang=js"

import "./SupportFab.vue?vue&type=style&index=0&id=4c25de0d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c25de0d"]])

export default __exports__